export enum NotificationCardTypes {
  CHALLENGE = 'CHALLENGE',
  IDEA = 'IDEA',
  COMMENT = 'COMMENT',
  BLOG_POST = 'BLOG_POST',
  BLOG_COMMENT = 'BLOG_COMMENT'
}
